// 一些常量的过滤
/** 把选项数字变成ABCD
 * @method optionConstant
 * @param {string} val 
 */
export const optionConstant = (val) => {
  switch (val * 1) {
    case 1:
      return 'A'
    case 2:
      return 'B'
    case 3:
      return 'C'
    case 4:
      return 'D'
    case 5:
      return 'E'
    case 6:
      return 'F'
    case 7:
      return 'G'
    default:
      return ''
  }
}

/** 把选项数字变成中文数字
 * @method optionConstant
 * @param {string} val 
 */
export const numConstant = (val) => {
  switch (val * 1) {
    case 1:
      return '一'
    case 2:
      return '二'
    case 3:
      return '三'
    case 4:
      return '四'
    case 5:
      return '五'
    case 6:
      return '六'
    case 7:
      return '七'
    case 8:
      return '八'
    case 9:
      return '九'
    default:
      return ''
  }
}



// WEBPACK FOOTER //
// ./src/filters/constant.js